import { Layout } from '@components/common'
import type {
    GetStaticPropsContext,
    GetStaticPropsResult,
    InferGetStaticPropsType
} from 'next'
import cn from 'classnames'
import s from '@pagestyles/index.module.scss'
import slickStyles from '@commonStyles/Slick.module.scss'
import getCMSPage from '@pylot-data/api/operations/get-cms'
import { RichContent } from '@corratech/pylot-rich-content'
import React, { ReactElement, useEffect, useState } from 'react'
import type { CmsPage } from '@pylot-data/pylotschema'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useCmsPage } from '@pylot-data/hooks/cms/use-cms-page'
import { SEO, SEO_ENUMS } from '@components/seo'
import { ProductItem } from '@components/common/ProductTile/ProductTile'
import { iframeVideoPluginInit } from '@config/hooks/videoController'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'

// Highly unlikely to change. Even if admin user wats to change the content, they can swap page identifiers.
const CMS_PAGE_IDENTIFIER = 'home'

export async function getStaticProps({
    locale
}: GetStaticPropsContext): Promise<
    GetStaticPropsResult<{ cmsPageData: CmsPage | null | undefined }>
> {
    const cmsPageData = await getCMSPage({
        identifier: CMS_PAGE_IDENTIFIER,
        locale
    })

    return {
        props: {
            cmsPageData,
            ...(await serverSideTranslations(locale!, ['common', 'wishlist']))
        },
        revalidate: 14400
    }
}

export default function Home({
    cmsPageData
}: InferGetStaticPropsType<typeof getStaticProps>): ReactElement {
    const { cmsPage = cmsPageData } = useCmsPage(CMS_PAGE_IDENTIFIER, {
        revalidateOnFocus: false,
        revalidateOnMount: true,
        initialData: cmsPageData
    })
    const { setPageType } = useAlfakherContext()
    const [scrollInitiated, setScrollInitiated] = useState(false)

    if (typeof window != 'undefined') {
        iframeVideoPluginInit()
    }

    useEffect(() => {
        setPageType({
            transparentHeader: !!cmsPage?.is_transparent_header,
            isNicotinePage: !!cmsPage?.has_nicotine
        })
    }, [cmsPage])

    useEffect(() => {
        const handleScroll = () => {
            if (!scrollInitiated) {
                setScrollInitiated(true)
                document.removeEventListener('scroll', handleScroll)
            }
        }

        document.addEventListener('scroll', handleScroll)
    }, [])
    /* eslint-disable i18next/no-literal-string */
    return (
        <div className={cn(s['homepage'], slickStyles.root)}>
            <SEO page={SEO_ENUMS.HOME} cmsPage={cmsPage} />
            <RichContent html={cmsPage?.content} ProductTile={ProductItem} />
            {/*{scrollInitiated && <TopThreeBlogPost />}*/}
        </div>
    )
}

Home.Layout = Layout
